<div class="container-main">
    <div class="container ">
        <div class="row justify-content-center text-center">
            <div class="col-lg-6 col-xl-4 login-wrapper">
                <div class="row">
                    <div class="col" style="padding-top: 20px; padding-bottom: 5px;">
                        <h1>Visit Cancelled</h1>

                        <p>We're sorry, but it seems that your visit has been cancelled. If you have any further questions, you can contact us via the numbers listed in the bottom of the page. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
